import moment from 'moment';
import 'moment/locale/pt-br';

const dateToBr = (date) => !!date ? moment(date).format('DD/MM/YYYY') : '';

const dateHourToBr = (date) => !!date ? moment.utc(date).format('DD/MM/YYYY - HH:mm') : '';

const hourToBr = (date) => (!!date ? moment(date).format('HH:mm:ss') : '');

const dateWeekHourToBr = (date) => !!date ? moment.utc(date).locale('pt-br').format('LLLL') : '';

const diffDateDays = (start, end, limit) => {
  const dateStart = moment(start);
  const dateEnd = moment(end);
  const duration = moment.duration(dateEnd.diff(dateStart));
  const days = duration.asDays();
  return days > limit;
};

const validateData = (val, required = false) => {
  if (!val) {
    if (!required) {
      return true;
    } else {
      return false;
    }
  }

  let date = val.split('/');

  if (date.length < 3) {
    return false;
  }
  let day = parseInt(date[0]),
    month = parseInt(date[1]),
    year = parseInt(date[2]);

  if (day < 1 || day > 31) {
    return false;
  }
  if (month < 1 || month > 12) {
    return false;
  }
  if (year.toString().length < 4) {
    return false;
  }
  return true;
};

const selectAllDates = (dateIni, dateEnd) => {
  if (
    (dateIni !== '' && dateEnd === '') ||
    (dateIni === '' && dateEnd !== '')
  ) {
    return true;
  }
  return false;
};

export {
  dateToBr,
  dateHourToBr,
  dateWeekHourToBr,
  hourToBr,
  diffDateDays,
  selectAllDates,
  validateData,
};
